import React, { useEffect, useMemo, useState } from "react";
import Modal from './Modal';
import ModalLink from './ModalLink';

export type NusukPackage = {
  id: number;
  nameEn: string;
  serviceProviderNameEn: string;
  zoneNameEn: string;
  housingZoneNameEn:string;
  totalPrice: number;
  packageDurationDays: number;
  availableSeats: number;
  imageUrl?: string;
  packageCategoryName: string;
  startDate: string;
  endDate: string;
  descriptionEn: string;
  MakkahHotelName: string;
  MadinahHotelName: string;
  AziziyahHotelName: string;
  madinahRating: number;
  aziziyahRating: number;
  makkahRating: number;
  FlightPrice: number;
  MakkahRooms: string;
  MadinahRooms: string;
  AziziyahRooms: string;
  Airline: string;
  MakkahDurationNights: number;
  MadinahDurationNights: number;
  AziziyahDurationNights: number;
  FlightsFrom: string;
};

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: NusukPackage | null;
}

function displayStars(count: number): string {
  // Ensure count is a non-negative integer
  const numStars = Math.max(0, Math.floor(count));
  return '⭐'.repeat(numStars); // Repeat the star symbol 'numStars' times
}

export default function App() {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<NusukPackage | null>(null);

  const handleLinkClick = (id: number) => {
    const selectedContent = packages.find(item => item.id === id);
    if (selectedContent) {
      setModalContent(selectedContent);
      setIsModalOpen(true);
    }
  };

  const cities: string[] = ['JNB', 'CPT', 'DBN'];
  const plancategories: string[] = ['Non-Shifting', ' Shifting'];

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null); // Optional: Clear content on close
  };
  const [packages, setPackages] = useState<NusukPackage[]>([]);
  const [filters, setFilters] = useState({
    search: "",
    provider: "",
    maxPrice: "",
    zone: "",
    category: "",
    departureCity: "",
  });
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'long', // 'long' gives "May", 'short' gives "May"
    year: 'numeric',
  };
  useEffect(() => {
    fetch("/nusukV12.json")
      .then((res) => res.json())
      .then(setPackages)
      .catch(console.error);
  }, []);
  const providers = useMemo(() => {
    const set = new Set(packages.map((p) => p.serviceProviderNameEn));
    return Array.from(set);
  }, [packages]);
  const departureCities = useMemo(() => {
    const set = new Set(packages.map((p) => p.FlightsFrom));
    return Array.from(cities);
  }, [packages]);
  const zones = useMemo(() => {
    const set = new Set(packages.map((p) => p.zoneNameEn));
    return Array.from(set);
  }, [packages]);
  const categories = useMemo(() => {
    const set = new Set(packages.map((p) => p.packageCategoryName));
    return Array.from(plancategories);
  }, [packages]);
  const filtered = useMemo(() => {
    return packages.filter((p) => {
      if (filters.search && !p.nameEn.toLowerCase().includes(filters.search.toLowerCase())) return false;
      if (filters.provider && p.serviceProviderNameEn !== filters.provider) return false;
      if (filters.departureCity && !p.FlightsFrom.includes(filters.departureCity)) return false;
      if (filters.zone && p.zoneNameEn !== filters.zone) return false;
      if (filters.maxPrice && p.totalPrice > Number(filters.maxPrice)) return false;
      if (filters.category && !p.packageCategoryName.includes(filters.category)) return false;
      return true;
    });
  }, [packages, filters]);
  return (
    <>
      <div style={styles.page} className="page-container">
        <header style={styles.header}>
          <h1 style={styles.title}>Nusuk South African Packages</h1>
          <div style={styles.filters} className="filters-grid">

            {
              /*
            <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', border: '1px solid #ccc', borderRadius: '4px', padding: '15px' }} onClick={() => setShowAdvancedFilters((v) => !v)}>
              <div>{showAdvancedFilters ? 
    (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-up w-5 h-5 text-muted-foreground" aria-hidden="true"><path d="m18 15-6-6-6 6"></path></svg>): 
    (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down w-5 h-5 text-muted-foreground" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>)}</div>
              <div ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-funnel w-5 h-5 text-primary" aria-hidden="true"><path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z"></path></svg></div>
              <div>Filters</div>
              {//<div style={{marginLeft: 'auto', paddingRight: '11px', fontSize: '12px'}}><strong>X</strong> Clear All</div>
              }
            </div>
            
            
            
{showAdvancedFilters && (
    <>
    */}
    <input
              style={styles.input}
              placeholder="Search package"
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            />
            <select
              style={styles.input}
              value={filters.category}
              onChange={(e) => setFilters({ ...filters, category: e.target.value })}
            >
              <option value="">All Categories</option>
              {plancategories.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
            <select
              style={styles.input}
              value={filters.provider}
              onChange={(e) => setFilters({ ...filters, provider: e.target.value })}
            >
              <option value="">All Providers</option>
              {providers.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
            <select
              style={styles.input}
              value={filters.zone}
              onChange={(e) => setFilters({ ...filters, zone: e.target.value })}
            >
              <option value="">All Zones</option>
              {zones.map((z) => (
                <option key={z} value={z}>{z}</option>
              ))}
            </select>
            <select
              style={styles.input}
              value={filters.departureCity}
              onChange={(e) => setFilters({ ...filters, departureCity: e.target.value })}
            >
              <option value="">Departure City</option>
              {departureCities.map((z) => (
                <option key={z} value={z}>{z}</option>
              ))}
            </select>
            {/*<input
              type="number"
              style={styles.input}
              placeholder="Max price (SAR)"
              value={filters.maxPrice}
              onChange={(e) => setFilters({ ...filters, maxPrice: e.target.value })}
            />*/}
            {/*</>)*/}
          </div>

          
        </header>
        <main style={styles.content} className="cards-grid">
          {filtered.map((p) => (
            <div key={p.id} style={styles.card}>
              {//p.imageUrl && (
                //<img src={p.imageUrl} alt={p.nameEn} style={styles.image} />
                //)
              }
              <div className="package-name" >
                <div style={{ fontSize: '12px', fontWeight: 'lighter',color:'#EAF4EF', lineHeight:'30px' }}>
                  <strong>{p.serviceProviderNameEn}</strong>
                </div>
                <div style={{ fontSize: '18px', fontWeight: 'normal',color:'#EAF4EF', fontStyle: 'italic' }}>
                  <strong>{p.nameEn}</strong></div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}><div style={{ fontSize: '10px', fontStyle: 'italic', textAlign: 'center', paddingRight: '5px' }}>from</div>
                  <div style={{ fontSize: '38px', fontWeight: '600' }}> R{(p.totalPrice * 4.4).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}</div>
                  <div style={{ fontSize: '10px', fontStyle: 'italic', textAlign: 'center', paddingRight: '5px' }}>excl flights</div>
                  
                </div>
                <div style={{ fontSize: '12px', fontWeight: 'normal',color:'#EAF4EF', fontStyle: 'italic' }}>
                  SAR{(p.totalPrice).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}</div>
              </div>
              <div style={styles.cardBody}>
                <div style={styles.row}>
                  <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', width: '100%' }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', textAlign: 'center', paddingRight: '5px',lineHeight:'14px' }}>{p.packageDurationDays} nights · </div>
                    <div style={{ fontSize: '12px',lineHeight:'14px' }}><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-calendar w-3 h-3" aria-hidden="true"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg> {new Date(p.startDate).toLocaleDateString('en-GB', options)} - {new Date(p.endDate).toLocaleDateString('en-GB', options)}</div>
                  </div>

                </div>

                <div style={{ ...styles.mutedSmall, lineHeight: '3' }} >
                  <span className="meta" style={{ backgroundColor: 'lightgray', color: 'darkgreen' }}>{p.packageCategoryName}</span>&nbsp;&nbsp;<span className="meta" style={{ backgroundColor: 'lightgray', color: 'darkgreen' }}>{p.zoneNameEn} </span>
                </div>


                <div style={styles.mutedSmall}>
                  <div>
                    <div >Makkah ({p.MakkahDurationNights} nights) {'⭐'.repeat(p.makkahRating)}<br />
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-hotel w-4 h-4 mt-0.5 text-primary flex-shrink-0" aria-hidden="true"><path d="M10 22v-6.57"></path><path d="M12 11h.01"></path><path d="M12 7h.01"></path><path d="M14 15.43V22"></path><path d="M15 16a5 5 0 0 0-6 0"></path><path d="M16 11h.01"></path><path d="M16 7h.01"></path><path d="M8 11h.01"></path><path d="M8 7h.01"></path><rect x="4" y="2" width="16" height="20" rx="2"></rect></svg>
                  <strong> {p.MakkahHotelName}</strong> · {p.zoneNameEn === "Zone M" ? ("Zone M (Aziziyah)") : p.zoneNameEn === "Zone A | M" ? ("Zone A") : p.zoneNameEn}<br />
                  <svg width="13" height="13" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">

<path d="M0 0h48v48H0z" fill="none"></path>
<g id="Shopicon">
	<path d="M40,12H8v16H4v10v2v4h4v-4h32v4h4v-4v-2V28h-4V12z M16,26c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2s-0.897,2-2,2H18
		C16.897,28,16,27.103,16,26z M12,16h24v10c0-3.309-2.691-6-6-6H18c-3.309,0-6,2.691-6,6V16z M40,36H8v-4h10h12h10V36z"></path>
</g>
</svg> {p.MakkahRooms}</div><br />
                    <div >Madinah ({p.MadinahDurationNights} nights) {'⭐'.repeat(p.madinahRating)}<br />
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-hotel w-4 h-4 mt-0.5 text-primary flex-shrink-0" aria-hidden="true"><path d="M10 22v-6.57"></path><path d="M12 11h.01"></path><path d="M12 7h.01"></path><path d="M14 15.43V22"></path><path d="M15 16a5 5 0 0 0-6 0"></path><path d="M16 11h.01"></path><path d="M16 7h.01"></path><path d="M8 11h.01"></path><path d="M8 7h.01"></path><rect x="4" y="2" width="16" height="20" rx="2"></rect></svg>
                  <strong> {p.MadinahHotelName}</strong><br />
                  <svg width="13" height="13" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">

<path d="M0 0h48v48H0z" fill="none"></path>
<g id="Shopicon">
	<path d="M40,12H8v16H4v10v2v4h4v-4h32v4h4v-4v-2V28h-4V12z M16,26c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2s-0.897,2-2,2H18
		C16.897,28,16,27.103,16,26z M12,16h24v10c0-3.309-2.691-6-6-6H18c-3.309,0-6,2.691-6,6V16z M40,36H8v-4h10h12h10V36z"></path>
</g>
</svg> {p.MadinahRooms}</div><br />
                    {p.AziziyahDurationNights > 0 && (
                      <div><div >Aziziyah ({p.AziziyahDurationNights} nights) {'⭐'.repeat(p.aziziyahRating)}<br />
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-hotel w-4 h-4 mt-0.5 text-primary flex-shrink-0" aria-hidden="true"><path d="M10 22v-6.57"></path><path d="M12 11h.01"></path><path d="M12 7h.01"></path><path d="M14 15.43V22"></path><path d="M15 16a5 5 0 0 0-6 0"></path><path d="M16 11h.01"></path><path d="M16 7h.01"></path><path d="M8 11h.01"></path><path d="M8 7h.01"></path><rect x="4" y="2" width="16" height="20" rx="2"></rect></svg>
                      <strong>{p.AziziyahHotelName}</strong><br />
                      <svg width="13" height="13" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">

<path d="M0 0h48v48H0z" fill="none"></path>
<g id="Shopicon">
	<path d="M40,12H8v16H4v10v2v4h4v-4h32v4h4v-4v-2V28h-4V12z M16,26c0-1.103,0.897-2,2-2h12c1.103,0,2,0.897,2,2s-0.897,2-2,2H18
		C16.897,28,16,27.103,16,26z M12,16h24v10c0-3.309-2.691-6-6-6H18c-3.309,0-6,2.691-6,6V16z M40,36H8v-4h10h12h10V36z"></path>
</g>
</svg> {p.AziziyahRooms}</div><br /></div>
                    )}
                  </div>
                  <div >✈ {p.Airline} ({p.FlightsFrom}) · approx R {(p.FlightPrice).toLocaleString()}</div>

                </div>

              </div>
              <ModalLink
                id={p.id}
                label={`View More Details →`}
                onClick={handleLinkClick}
              />
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={styles.empty}>No packages found</div>
          )}
          <div style={{ backgroundColor: 'lightyellow', display: 'block', fontSize: 'small', padding: '5px', marginTop: '7px' }}>
            This page is to view packages only.<br />Total price excludes Flights, Adahi & Room Customisation<br />
            Exchange rate used is 1 SAR = 4.4 ZAR <br />
            All configurations and purchases are made via <a style={{ color: 'black', fontWeight: 'bold', textDecoration: 'underline' }} target="_default" href="https://hajj.nusuk.sa/">NUSUK</a>.
            </div>
        </main>
        <Modal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          content={modalContent}
        />
      </div>

      <style>{`
        @media (min-width: 640px) {
          .filters-grid {
          margin: 0 auto;
          grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (min-width: 1024px) {
          .page-container {
            max-width: 100%;
          }
          .filters-grid {
          margin: 0 auto;
            grid-template-columns: repeat(4, 1fr);
          }
          .cards-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }
          
        }
          .meta {
            padding:4px;
            
            background:lightblue;
            border-radius:8px;
            font-weight:650;
          }

          toggleButton: {
            padding: "10px 12px",
            borderRadius: 10,
            border: "1px solid #d1d5db",
            background: "#f9fafb",
            fontSize: 14,
            cursor: "pointer",
            textAlign: "center",
          }
      `}</style>
    </>
  );
}
const styles: Record<string, React.CSSProperties> = {
  globalFix: {
    boxSizing: "border-box",
  },
  page: {
    minHeight: "100vh",
    background: "#f3f4f6",
  },
  header: {
    top: 0,
    background: "#ffffff",
    padding: "12px 16px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    zIndex: 10,
    boxSizing: "border-box",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 8,
  },
  filters: {
    display: "grid",
    maxWidth: "100%",
    gridTemplateColumns: "1fr",
    gap: 8,
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    fontSize: 14,
    boxSizing: "border-box",
  },
  content: {
    maxWidth: 1024,
    margin: "0 auto",
    padding: 14,
    boxSizing: "border-box",
  },
  card: {
    background: "#ffffff",
    borderRadius: 16,
    overflow: "hidden",
    marginBottom: 16,
    boxShadow: "0 6px 14px rgba(0,0,0,0.06)",
     gridTemplateRows: "auto 1fr auto",
  height: "100%",
  display:"grid"
  },
  image: {
    width: "100%",
    height: 180,
    objectFit: "cover",
  },
  cardBody: {
    padding: 12,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 4,
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 8,
    fontSize: 14,
  },
  muted: {
    fontSize: 12,
    color: "#6b7280",
  },
  mutedSmall: {

    fontSize: 13,
    color: "#6b7280",
    marginTop: 6,
  },
  mutedSmallRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 12,
    color: "#6b7280",
    marginTop: 6,
    fontWeight: 650,
    lineHeight: 1.8
  },
  empty: {
    textAlign: "center",
    color: "#6b7280",
    marginTop: 40,
  },
};
